// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQ_root__3Chju","questions":"FAQ_questions__QKfZc","questionItem":"FAQ_questionItem__8Ko0Z","heading":"FAQ_heading__4Gfxk","answer":"FAQ_answer__r7HK3"};